import React, { Component } from 'react';
import TextField from 'material-ui/TextField';
import Button from 'material-ui/Button';
import Typography from 'material-ui/Typography';
import OptyDialog from './OptyDialog';
import bn from 'bignumber.js';
import api from './api';
import { formatNumField } from "./format";

class Underwrite extends Component {
  state = {
    options: ""
  }

  canUnderwrite() {
    return this.state.options > 0;
  }

  underwrite() {
    const { strike, type } = this.props;

    //TODO: handle not authorized...
    api.log.handle("underwrite-options", () => strike[type].underwrite(+this.state.options));
    this.setState({
      options: ''
    })
  }

  render() {
    const { strike, type } = this.props;
    const { options } = this.state;
    const amount = type === 'put' ? 
      formatNumField(bn(options || 0).times(bn(strike.price)), Math.min(5, strike.pair.currency.decimals)) : 
      formatNumField(bn(options || 0), Math.min(5, strike.pair.target.decimals));
    const symbol = type === 'put' ? strike.pair.currency.symbol : strike.pair.target.symbol;

    return (
      <div>
        <Button variant='raised' color='primary' disabled={!strike || !type} onClick={()=>this.dialog.run()}>Underwrite</Button>
        <OptyDialog ref={d=>{this.dialog = d}} title={'Underwrite ' + type.toUpperCase() + " " + strike.label()} okDisabled={!this.canUnderwrite()} onOK={()=>this.underwrite()} okLabel="Underwrite">
          <TextField label="How many options?" value={options} onChange={(event)=>this.setState({options:formatNumField(event.target.value)})}/>
          <Typography>Requires {amount} {symbol}</Typography>
        </OptyDialog>
      </div>
    )
  }
}

export default Underwrite;


// WEBPACK FOOTER //
// ./src/Underwrite.js